import * as React from "react";

/**
 * Keeps the browser tab title in sync on client-side navigation.
 *
 * Prerendering bakes the correct <title> into the static HTML for a fresh
 * page load (see scripts/prerender.ts), but nothing updates `document.title`
 * when React Router swaps routes without a full reload — so a user clicking
 * through the app in one session keeps seeing whichever page's title loaded
 * first. Doesn't affect crawlers (they fetch the prerendered file per URL
 * regardless); fixes the tab/bookmark bug and closes an accessibility gap
 * (screen readers rely on title changes to announce SPA navigation).
 */
export function useDocumentTitle(title: string | null | undefined): void {
  React.useEffect(() => {
    if (!title) return;
    document.title = title;
  }, [title]);
}
